import React, { Component } from 'react';
import Modal from 'utils/components/modal';
import BroadcastModal from '../../modals/broadcast';

class BroadcastFAQ extends Component {
  openModal() {
    this.refs.broadcastModal.show();
  }
  closeModal() {
    this.refs.broadcastModal.hide();
  }
  render() {
    return (
      <div className="faqs">
        <div className="faq">What is a Broadcast?</div>
        <div className="faq-description">
          Send an instant notification to all users visiting your site, along with a link to promote
          your content.
        </div>
        <div className="faq-description" style={{ marginTop: 20 }}>
          See where it will{' '}
          <a className="faq-link" onClick={this.openModal.bind(this)}>
            appear
          </a>{' '}
          on-screen.
        </div>
        <div className="faq">Who will receive the Broadcast?</div>
        <div className="faq-description">
          Everyone visiting your site will receive the Broadcast, registered users and guests alike.
        </div>
        <div className="faq">Still have questions?</div>
        <div className="faq-description">
          <span>
            Go ahead and{' '}
            <a className="faq-link" href="https://spot.im/contact" target="_blank">
              contact our support team.
            </a>
          </span>
        </div>
        <Modal ref="broadcastModal" className="modal-broadcast">
          <BroadcastModal onClose={this.closeModal.bind(this)} />
        </Modal>
      </div>
    );
  }
}

BroadcastFAQ.displayName = 'BroadcastFAQ';

export default BroadcastFAQ;
